const userType = {
  EXTERNAL: 'external',
  REGULAR: 'regular',
};

export default userType;
